import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-avatarselect',
  templateUrl: './avatarselect.component.html',
  styleUrls: ['./avatarselect.component.scss'],
})
export class AvatarselectComponent implements OnInit {
  public avatarsPath = [];
  constructor(public modalController: ModalController) { }

  ngOnInit() {

    this.avatarsPath = [];
    const avatars = 75;
    for (let i = 0; i < avatars; i++) {
      this.avatarsPath.push('./../../../assets/avatars/' + i + '.png');
    }
  }
  selectAvatar(index) {
    this.modalController.dismiss({ idx: index }, '');
  }

}
